



import ContentsListComponent from "@/components/admin/contents/contentsListComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "ContentsListPage",
  components: {
    ContentsListComponent,
  },
})
export default class ContentsListPage extends Vue {}
